import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, CertificateIcon } from '../icons/SalesIcons';
export function BonusSection() {
  const bonuses = [{
    num: 1,
    title: 'Aguas de Lino y Difusor Colgante',
    desc: 'Aprende a crear productos complementarios para tu línea'
  }, {
    num: 2,
    title: 'Difusor de Varitas',
    desc: 'Técnica completa para difusores elegantes'
  }, {
    num: 3,
    title: 'Plantilla de Costos para tus Velas',
    desc: 'Indispensable para vender con ganancia real',
    highlight: true
  }, {
    num: 4,
    title: 'Lista de Proveedores Verificados',
    desc: 'Contactos de confianza para tus materiales',
    highlight: true
  }, {
    num: 5,
    title: 'Velas Navideñas Especiales',
    desc: 'Diseños temáticos para temporada alta'
  }, {
    num: 6,
    title: 'Técnica Coral Exclusiva',
    desc: 'Efecto decorativo único y llamativo'
  }, {
    num: 7,
    title: 'Fanal para Velas',
    desc: 'Crea portavelas decorativos'
  }, {
    num: 8,
    title: 'Velón con Incrustaciones Florales',
    desc: 'Técnica avanzada con flores preservadas'
  }];
  return <section className="bg-gradient-to-br from-[#9B2335] to-[#7a1c2a] py-16 md:py-24" data-id="element-68">
      <div className="max-w-6xl mx-auto px-4" data-id="element-69">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-70">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-71">
            <GiftIcon size={40} className="text-[#C4A882]" data-id="element-72" />
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-white mb-4" data-id="element-73">
            Tus Bonos Incluidos
          </h2>
          <p className="text-xl text-[#D4A0A0]" data-id="element-74">
            8 regalos exclusivos + certificado de finalización
          </p>
        </motion.div>

        {/* Bonuses Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-75">
          {bonuses.map((bonus, index) => <motion.div key={bonus.num} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`bg-white/10 backdrop-blur-sm rounded-xl p-6 border ${bonus.highlight ? 'border-[#C4A882] ring-2 ring-[#C4A882]/50' : 'border-white/20'} hover:bg-white/15 transition-all duration-300`} data-id="element-76">
              <div className="flex items-center gap-3 mb-4" data-id="element-77">
                <div className="w-10 h-10 rounded-full bg-[#C4A882] flex items-center justify-center" data-id="element-78">
                  <GiftIcon size={20} className="text-white" data-id="element-79" />
                </div>
                <span className="text-[#C4A882] font-bold" data-id="element-80">
                  Bono {bonus.num}
                </span>
              </div>
              <h3 className="font-heading text-lg text-white mb-2" data-id="element-81">
                {bonus.title}
              </h3>
              <p className="text-sm text-[#D4A0A0]" data-id="element-82">{bonus.desc}</p>
              <div className="mt-4 inline-block px-3 py-1 bg-[#C4A882]/20 rounded-full" data-id="element-83">
                <span className="text-xs font-bold text-[#C4A882] uppercase" data-id="element-84">
                  Incluido
                </span>
              </div>
            </motion.div>)}
        </div>

        {/* Certificate Card */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="bg-gradient-to-r from-[#C4A882] to-[#D4A0A0] rounded-2xl p-8 text-center" data-id="element-85">
          <div className="flex items-center justify-center gap-4 mb-4" data-id="element-86">
            <CertificateIcon size={48} className="text-[#5C4033]" data-id="element-87" />
          </div>
          <h3 className="font-heading text-2xl text-[#5C4033] mb-2" data-id="element-88">
            Certificado de Finalización
          </h3>
          <p className="text-[#5C4033]/80" data-id="element-89">
            Obtén tu certificado descargable que respalda tu formación como
            velera artesanal
          </p>
          <div className="mt-4 inline-block px-4 py-2 bg-white/50 rounded-full" data-id="element-90">
            <span className="font-bold text-[#9B2335] uppercase" data-id="element-91">
              Incluido con tu curso
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}